import Test from '../AppMain/Test';
import { cEl } from '../../util';
import Home from '../AppMain/Home';
import Contact from '../AppMain/Contact';
import Learn from '../AppMain/Learn';
import { PATH_ADMIN_HOME, PATH_CONTACT, PATH_HOME, PATH_LEARN, PATH_TEST } from '../path';
import { getHandler } from '../../globalVariable';
import Admin from '../AppMain/Admin';
import AppHeader from './index';
import { initializePersistentState } from '../AppMain/Admin/Submissions/Table';

function Link({ handleClick, innerHTML, href }) {
    const link = cEl('a');
    link.innerHTML = innerHTML;
    link.href = href;

    if (getHash() === href) {
        link.classList.add('active');
    }

    link.addEventListener('click', e => {
        e.preventDefault();
        if (typeof handleClick === 'function') {
            handleClick(e);
        }
        if (link.href) {
            navigateTo(link.href);
        }
    });
    return link;
}

export const navigateTo = (url, noRecord) => {
    if (!noRecord) {
        window.history.pushState(null, null, url);
    }
    getHandler('locationChangeHandler')(window.location);

    renderHeader();
    renderMainView(getHash());
};

const renderHeader = () => {
    const root = document.getElementById('root');
    if (root) {
        const header = root.querySelector('header');
        header.querySelectorAll('*').forEach(el => {
            el.replaceWith(el.cloneNode(true));
        });
        root.removeChild(header);

        document.getElementById('root').prepend(AppHeader());
        handleNavigation();
    }
};

const handleNavigation = () => {
    const nav = document.querySelector(`.right-nav a[href=${encodeHashSelector()}]`);
    activateNav(nav);
};

const activateNav = nav => {
    document.querySelectorAll('.right-nav a').forEach(el => {
        el.classList.remove('active');
    });
    if (nav) {
        nav.classList.add('active');
    }
};

export const renderMainView = (hash, main) => {
    const newMain = main ?? document.querySelector('.app-main');

    if (newMain) {
        newMain.innerHTML = '';

        if (matchHash(PATH_ADMIN_HOME)) {
            newMain.appendChild(Admin());
            return;
        }
        initializePersistentState();
        switch (hash) {
            case PATH_HOME:
                newMain.appendChild(Home(main));
                break;
            case PATH_LEARN:
                newMain.appendChild(Learn());
                break;
            case PATH_TEST:
                newMain.appendChild(Test());
                break;
            case PATH_CONTACT:
                newMain.appendChild(Contact());
                break;
            default:
                break;
        }
    }
};

export const getHash = () => {
    return window.location.hash || PATH_HOME;
};

const getPath = () => {
    return getHash().slice(1);
};

const encodeHashSelector = () => {
    return getHash()
        .replace(/\?.*$/, '')
        .replace(/[/#]/g, match => '\\' + match);
};

export const matchHash = routingPath => {
    if (!routingPath) {
        return false;
    }
    const hash = getHash();

    const paramRegExp = /:(\w+)/g;

    const pathRegExpStr = routingPath.replace(paramRegExp, '');
    const pathRegExp = new RegExp(pathRegExpStr, 'g');

    return pathRegExp.test(hash);
};

export const getPathVariables = routingPath => {
    if (!routingPath) {
        return null;
    }

    const hash = getHash();
    const paramRegExp = /:(\w+)/g;

    const pathRegExpStr = routingPath.replace(paramRegExp, '');
    const pathRegExp = new RegExp(pathRegExpStr, 'g');

    const param = {};

    let match;
    while ((match = paramRegExp.exec(routingPath)) !== null) {
        param[match[1]] = pathRegExp.exec(hash)?.[1];
    }

    return param;
};

export default Link;
